import { useMemo } from 'react';
import { getImpersonation, Impersonation } from 'auth';
import { useAuth } from './useAuth';

/** Returns who the org user is logged in as, or null when the current tab is not an org impersonation. */
export const useImpersonation = (): Impersonation | null => {
    const auth = useAuth();

    // Re-read on sign in/out so the marker follows the session of this tab.
    return useMemo(() => (auth.signedIn ? getImpersonation() : null), [auth.signedIn, auth.user?.id]);
};

export default useImpersonation;
